import {
    EXPORT_DISCOUNT_CODES,
    EXPORT_DISCOUNT_CODES_FAILURE,
    EXPORT_DISCOUNT_CODES_SUCCESS,
} from 'store/actions/types';

export const exportDiscountCodes = (params) => {
    return {
        type: EXPORT_DISCOUNT_CODES,
        params: params,
    };
};

export const exportDiscountCodesFailure = () => {
    return {
        type: EXPORT_DISCOUNT_CODES_FAILURE,
        error: true,
    };
};

export const exportDiscountCodesSuccess = () => {
    return {
        type: EXPORT_DISCOUNT_CODES_SUCCESS,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discountCodes/exportDiscountCodes.js